const e = "18.0.0";
export {
  e as RgThreeVersion
};
//# sourceMappingURL=index2.js.map
